import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadTask } from 'src/app/model/task-list/load-task';
import { SubmitRequestRegisteredAction } from './helper-interfaces/submit-request-registered-action';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { OfflineTaskChangesObject } from '../../offline-storage/offline-task-changes-object';
import { TaskSubmitHelper } from './task-submit-helper';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { Observable } from 'rxjs';
import { _put } from '../../../../base.service';

@Injectable({
  providedIn: 'root',
})
export class SubmitLoadTaskService {
  private static BASE_URL = '/task';
  private readonly put: <T>(
    path: string,
    body: SubmitRequestBody,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as LoadTask;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.put = _put(SubmitLoadTaskService.BASE_URL, requestServices);
  }

  public submit(taskChanges: OfflineTaskChangesObject): Promise<LoadTask> {
    const requestBody: SubmitRequestBody = {
      taskId: taskChanges.id,
      registeredActions: CollectionHelper.isPopulated(
        taskChanges.registeredActions
      )
        ? taskChanges.registeredActions.map((r) =>
            TaskSubmitHelper.mapToSubmitRequestRegisteredAction(r)
          )
        : [],
    };
    return this.put('/submitTask', requestBody, this.deserialize).toPromise();
  }
}

export interface SubmitRequestBody {
  taskId: number;
  registeredActions?: SubmitRequestRegisteredAction[];
}
